// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "app-" + chunkId + "." + {"679":"e5bc319b821401c42320","936":"bf53439e501ea3a0ebc2"}[chunkId] + ".js";
};